// extracted by mini-css-extract-plugin
module.exports = {"tnc-wrapper":"FF3OJY9fgVhXmmpVF0_qp"};